export async function encrypt(text, customKey) {
  const encoder = new TextEncoder();
  const iv = window.crypto.getRandomValues(new Uint8Array(16));
  // Hash the customKey to get a 32-byte key
  const hashedKey = await window.crypto.subtle.digest(
    "SHA-256",
    encoder.encode(customKey)
  );
  const key = await window.crypto.subtle.importKey(
    "raw",
    hashedKey,
    { name: "AES-CBC" },
    false,
    ["encrypt"]
  );
  const encrypted = await window.crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    key,
    encoder.encode(text)
  );
  return {
    iv: Array.from(iv)
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""),
    encryptedData: Array.from(new Uint8Array(encrypted))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""),
  };
}

export async function decryptMessage(encryptedHex, ivHex, customKey) {
  const encoder = new TextEncoder();
  // Convert hex to Uint8Array
  function hexToBytes(hex) {
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
    }
    return bytes;
  }
  const encryptedBytes = hexToBytes(encryptedHex);
  const iv = hexToBytes(ivHex);
  // Hash customKey to get 32-byte AES key
  const keyBuffer = await crypto.subtle.digest(
    "SHA-256",
    encoder.encode(customKey)
  );
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBuffer,
    { name: "AES-CBC" },
    false,
    ["decrypt"]
  );
  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv },
    cryptoKey,
    encryptedBytes
  );
  const decoder = new TextDecoder();
  return decoder.decode(decryptedBuffer);
}

// Helper to convert hex string to ArrayBuffer
function hexToBuffer(hex) {
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
  }
  return bytes.buffer;
}

export async function decryptText(encryptedBase64, privateKeyPem) {
  try {
    if (!privateKeyPem) return;
    const privateKey = await importPrivateKey(privateKeyPem);
    const encryptedBytes = Uint8Array.from(atob(encryptedBase64), (c) =>
      c.charCodeAt(0)
    );
    const decrypted = await crypto.subtle.decrypt(
      { name: "RSA-OAEP" },
      privateKey,
      encryptedBytes
    );
    // return new TextDecoder().decode(decrypted);
    return new TextDecoder().decode(decrypted);
  } catch (err) {
    console.log("Removed chat error", err);
  }
}

async function importPrivateKey(pem) {
  const b64 = pem?.replace(/-----(BEGIN|END) PRIVATE KEY-----|\n/g, "");
  const binary = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  return crypto.subtle.importKey(
    "pkcs8",
    binary,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["decrypt"]
  );
}
